import React from 'react';

export const TooltipSvg = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.44879 5.64533C8.94363 5.86857 8.71509 6.45905 8.93833 6.96421C9.16157 7.46937 9.75205 7.69791 10.2572 7.47467L9.44879 5.64533ZM11 14.5C11 15.0523 11.4477 15.5 12 15.5C12.5523 15.5 13 15.0523 13 14.5H11ZM22 12C22 17.5228 17.5228 22 12 22V24C18.6274 24 24 18.6274 24 12H22ZM12 22C6.47715 22 2 17.5228 2 12H0C0 18.6274 5.37258 24 12 24V22ZM2 12C2 6.47715 6.47715 2 12 2V0C5.37258 0 0 5.37258 0 12H2ZM12 2C17.5228 2 22 6.47715 22 12H24C24 5.37258 18.6274 0 12 0V2ZM12 18V20C13.1046 20 14 19.1046 14 18H12ZM12 18H10C10 19.1046 10.8954 20 12 20V18ZM12 18V16C10.8954 16 10 16.8954 10 18H12ZM12 18H14C14 16.8954 13.1046 16 12 16V18ZM10.2572 7.47467C11.1017 7.10148 12.0664 6.9424 12.8824 7.019C13.7229 7.09789 14.2142 7.3987 14.4193 7.73067L16.1207 6.67933C15.4508 5.5953 14.2236 5.13611 13.0693 5.02775C11.8906 4.9171 10.5843 5.14352 9.44879 5.64533L10.2572 7.47467ZM14.4193 7.73067C14.9155 8.53368 14.7199 9.65302 13.3945 10.7761L14.6875 12.3019C16.3621 10.883 17.3745 8.70832 16.1207 6.67933L14.4193 7.73067ZM13.3945 10.7761C11.9126 12.0318 11 12.9928 11 14.5H13C13 14.0072 13.1694 13.5882 14.6875 12.3019L13.3945 10.7761Z"
      fill="currentColor"
    />
  </svg>
);
